import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SessionNavToolbar } from './SessionNavToolbar';
import styles from './GlobalToolbarsOverlay.module.css';

/**
 * Renders the right-side toolbar as a fixed overlay on every page,
 * except when the live preview is in fullscreen mode or on session pages
 * (which embed their own toolbars in the layout).
 */
export function GlobalToolbarsOverlay() {
  const location = useLocation();
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const onChange = () => setIsFullscreen(!!document.fullscreenElement);
    document.addEventListener('fullscreenchange', onChange);
    return () => document.removeEventListener('fullscreenchange', onChange);
  }, []);

  // Hide when any element is in native fullscreen
  if (isFullscreen) return null;

  // Public / unauthenticated pages — no toolbar
  if (location.pathname === '/') return null;
  if (location.pathname === '/login') return null;
  if (location.pathname === '/pricing') return null;
  if (location.pathname === '/faq') return null;
  if (location.pathname === '/news') return null;
  if (location.pathname === '/privacy-policy') return null;
  if (location.pathname === '/terms-of-service') return null;
  if (location.pathname.startsWith('/join/')) return null;
  if (location.pathname.startsWith('/shared/')) return null;
  if (location.pathname.startsWith('/tsp-apply')) return null;

  // Pages that embed their own toolbars in the layout — skip to avoid duplication
  if (location.pathname.startsWith('/session/')) return null;
  if (location.pathname === '/dashboard') return null;
  if (location.pathname.startsWith('/taskingbot')) return null;

  // Show settings on all other pages including /taskingbot
  return (
    <div className={styles.container}>
      <SessionNavToolbar side="right" />
    </div>
  );
}
